import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const Result = ({ res }) => {
  const m = res.membre || {};
  if (m.verifie && m.membre) return <p className="text-emerald-800" data-testid="confirm-member-ok">Votre accès Membre APOLLO est activé.</p>;
  if (m.verifie && !m.membre) return <p className="text-slate-700" data-testid="confirm-member-ko">{m.message}</p>;
  if (m.raison === "indisponible") return <p className="text-slate-600" data-testid="confirm-member-later">La vérification de votre adhésion APOLLO reprendra un peu plus tard, automatiquement.</p>;
  return null;
};

export default function ConfirmEmail() {
  const { user, refresh } = useAuth();
  const [state, setState] = useState({ busy: true });
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = new URLSearchParams(window.location.search).get("token") || "";
    api.post("/auth/confirm-email", { token })
      .then((r) => { setState({ ok: true, res: r.data }); if (localStorage.getItem("apollo_token")) refresh().catch(() => {}); })
      .catch((e) => setState({ ok: false, error: formatApiError(e.response?.data?.detail) }));
  }, [refresh]);
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background" data-testid="confirm-email-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-8 space-y-4">
        <BrandLogo />
        {state.busy && <p className="inline-flex items-center gap-2 text-slate-600"><Loader2 className="h-4 w-4 animate-spin" /> Confirmation en cours…</p>}
        {state.ok && <>
          <p className="inline-flex items-center gap-2 font-semibold text-ink" data-testid="confirm-email-ok"><CheckCircle2 className="h-5 w-5 text-emerald-600" /> Adresse e-mail confirmée.</p>
          <Result res={state.res} />
        </>}
        {state.ok === false && <p className="inline-flex items-start gap-2 text-red-700" data-testid="confirm-email-error"><AlertCircle className="h-5 w-5 shrink-0" /> {state.error}</p>}
        {!state.busy && <Link to={user ? "/" : "/login"} data-testid="confirm-email-continue" className="inline-block bg-coral-strong text-white px-4 py-2.5 rounded-sm text-sm font-semibold hover:bg-coral-hover">{user ? "Aller sur Pulse" : "Se connecter"}</Link>}
      </div>
    </div>
  );
}
